import { createAction } from 'redux-actions';
import * as constants from 'constants/redux/conversation';

export const postMessageRequest = createAction(constants.POST_MESSAGE_REQUEST);
export const postMessageSuccess = createAction(constants.POST_MESSAGE_SUCCESS);
export const postMessageFailure = createAction(constants.POST_MESSAGE_FAILURE);

export const deleteMessageRequest = createAction(constants.DELETE_MESSAGE_REQUEST);
export const deleteMessageSuccess = createAction(constants.DELETE_MESSAGE_SUCCESS);
export const deleteMessageFailure = createAction(constants.DELETE_MESSAGE_FAILURE);

export const postMessageSeenRequest = createAction(constants.POST_MESSAGE_SEEN_REQUEST);

export const fetchConversationRequest = createAction(constants.FETCH_CONVERSATION_REQUEST);
export const fetchConversationSuccess = createAction(constants.FETCH_CONVERSATION_SUCCESS);
export const fetchConversationFailure = createAction(constants.FETCH_CONVERSATION_FAILURE);

export const clearConversation = createAction(constants.CLEAR_CONVERSATION);
export const clearPreviousConversation = createAction(constants.CLEAR_PREVIOUS_CONVERSATION);
export const fetchConversationFile = createAction(constants.FETCH_CONVERSATION_FILE);

export const conversationUploadFilePostInfo = createAction(
  constants.CONVERSATION_UPLOAD_FILE_POST_INFO,
);
export const conversationUploadFileSuccess = createAction(
  constants.CONVERSATION_UPLOAD_FILE_SUCCESS,
);
export const conversationUploadFileFailure = createAction(
  constants.CONVERSATION_UPLOAD_FILE_FAILURE,
);
export const conversationUploadFileIdle = createAction(constants.CONVERSATION_UPLOAD_FILE_IDLE);

export const postConversationTagsRequest = createAction(constants.POST_CONVERSATION_TAGS_REQUEST);
export const postConversationTagsSuccess = createAction(constants.POST_CONVERSATION_TAGS_SUCCESS);
export const postConversationTagsFailure = createAction(constants.POST_CONVERSATION_TAGS_FAILURE);

export const conversationAttachFromLibraryRequest = createAction(
  constants.CONVERSATION_ATTACH_FROM_LIBRARY_REQUEST,
);

export const updateConversationReview = createAction(constants.UPDATE_CONVERSATION_REVIEW);
